import * as React from "react";
import { Box, Typography } from "@mui/material";
import { platformFonts, platformScannerPanelSx, usePlatformColors } from "../tickitPlatformTheme";

export function PlatformScannerFrame({ children, scanLine = true }) {
  const colors = usePlatformColors();
  return (
    <Box
      sx={{
        width: 160,
        height: 160,
        borderRadius: "16px",
        border: `3px solid ${colors.brandLight}`,
        mx: "auto",
        mb: 2.5,
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        bgcolor: "rgba(107, 45, 197, 0.08)",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 8,
          left: 8,
          width: 24,
          height: 24,
          border: "3px solid #fff",
          borderRight: "none",
          borderBottom: "none",
          borderRadius: "4px 0 0 0",
          zIndex: 2,
          pointerEvents: "none",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: 8,
          right: 8,
          width: 24,
          height: 24,
          border: "3px solid #fff",
          borderLeft: "none",
          borderTop: "none",
          borderRadius: "0 0 4px 0",
          zIndex: 2,
          pointerEvents: "none",
        },
      }}
    >
      {scanLine && (
        <Box
          className="platform-scanner-line"
          sx={{
            position: "absolute",
            left: 0,
            right: 0,
            height: 2,
            background: `linear-gradient(90deg, transparent, ${colors.brandLight}, transparent)`,
            zIndex: 3,
            pointerEvents: "none",
          }}
        />
      )}
      <Box sx={{ position: "relative", zIndex: 1, width: "100%", height: "100%" }}>{children}</Box>
    </Box>
  );
}

export default function PlatformScannerPanel({
  title = "Point camera at QR code",
  status,
  actions,
  children,
}) {
  return (
    <Box sx={platformScannerPanelSx}>
      <Typography
        sx={{
          fontFamily: platformFonts.display,
          fontSize: 14,
          fontWeight: 700,
          color: "rgba(255,255,255,0.6)",
          mb: 2,
          letterSpacing: 1,
          textTransform: "uppercase",
        }}
      >
        {title}
      </Typography>
      {children}
      <Box sx={{ minHeight: 60, mt: 1 }}>{status}</Box>
      {actions && (
        <Box sx={{ display: "flex", gap: 1, justifyContent: "center", mt: 2, flexWrap: "wrap" }}>
          {actions}
        </Box>
      )}
    </Box>
  );
}
